
import Airplane from "../../../assets/duotone/Airplane.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AirplaneIcon({ className, dataTestid = "AirplaneIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Airplane data-testid={dataTestid} className={classes} {...rest} />
  );
}
